import React from 'react';
import { useAuth } from '../contexts/auth';
import { Navigate, useLocation } from 'react-router-dom';


const DefaultRoute: React.FC = () => {
    const { isAuthenticated } = useAuth();
    const location = useLocation(); // Use the useLocation hook to get the current location

    return isAuthenticated ? (
        <Navigate to="/matchboard" replace state={{ from: location }} />
    ) : (
        <Navigate to="/login" replace state={{ from: location }} />
    );
};

export default DefaultRoute;